import { styled } from '@mui/system';
import COLORS from '../../../theme/Colors';

export const LogoImg = styled('img')({
  objectFit: 'contain',
  //   filter: 'brightness(0) invert(1)',
});

export const FoundationImg = styled('img')({
  width: '147px',
  aspectRatio: '3/2',
  objectFit: 'contain',
  alignSelf: 'center',
});

export const ModalMessage = styled('h4')({
  color: COLORS.primary,
  fontSize: '0.8em',
  fontWeight: 300,
});

export const ModalTitle = styled('h1')({
  color: '#656565 !important',
  // letterSpacing: `0 !important`,
  textAlign: 'center',
  fontSize: '1.5em',
  fontWeight: 300,
});

export const ModalFooter = styled('p')({
  color: '#656565',
  fontSize: '0.6em',
  fontWeight: 300,
});
